module.exports = "<div class=bc-card ng-transclude></div>";